import LoadingBar from '~/components/LoadingBar';
import { readableSegmentType, searchDescription } from '~/lib/segments';

import { states as refreshStates } from '../useRefreshState';
import Check from './Check.svg';
import Update from './Update.svg';

const Separator = () => (
  <div className="inline ml-2 mr-2 border-l border-gray-200 border-solid" />
);

const RefetchForNewMatches = ({ resultsCount, onRefetch, type }) => {
  const readableCount = resultsCount?.toLocaleString();

  return (
    <div className="flex">
      <span>
        {readableCount} {readableSegmentType(type)}{' '}
      </span>
      <Separator />
      <a
        role="button"
        tabIndex={0}
        className="flex items-center cursor-pointer text-blue"
        onClick={() => onRefetch()}>
        <Update /> Update with new matches
      </a>
    </div>
  );
};

RefetchForNewMatches.propTypes = {
  resultsCount: PropTypes.number,
  onRefetch: PropTypes.func,
  type: PropTypes.string,
};

const Subtitle = ({
  currentResultsCount,
  originalResultsCount,
  segment,
  searchQuery,
  refreshState,
  onRefetch,
  loading,
}) => {
  if (loading) return 'Loading...';

  const readableCurrentResultsCount = currentResultsCount?.toLocaleString();

  switch (refreshState) {
    case refreshStates.checkingForNewMatches:
      return (
        <div>
          <span>
            {readableCurrentResultsCount} {readableSegmentType(segment?.type)}{' '}
          </span>
          <Separator />
          <LoadingBar className="inline-block w-20 ml-2 mr-2" /> Checking for
          new matches
        </div>
      );
    case refreshStates.segmentUpToDate:
      return (
        <div className="flex items-center text-green-500">
          <Check className="flex items-center mr-2" />
          Segment up to date
        </div>
      );
    case refreshStates.newMatchesAvailable:
      return (
        <div className="flex items-center text-green-500">
          <Check className="flex items-center mr-2" />
          New segment matches available.
        </div>
      );
    case refreshStates.refetchForNewMatches:
      return (
        <RefetchForNewMatches
          resultsCount={originalResultsCount}
          type={segment?.type}
          onRefetch={onRefetch}
        />
      );
    default:
      return (
        <div>
          {searchDescription(
            segment?.type,
            segment?.id,
            readableCurrentResultsCount,
            segment?.lastSearchedAt,
            searchQuery,
          )}{' '}
        </div>
      );
  }
};

Subtitle.propTypes = {
  segment: PropTypes.shape({
    type: PropTypes.string,
    id: PropTypes.string,
    lastSearchedAt: PropTypes.string,
  }),
  currentResultsCount: PropTypes.number,
  originalResultsCount: PropTypes.number,
  searchQuery: PropTypes.string,
  refreshState: PropTypes.string,
  onRefetch: PropTypes.func,
  loading: PropTypes.bool,
};

export default Subtitle;
